import AccountForm from '@/components/core/account/account.form'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/atoms/dialog'
import { useState } from 'react'

export default function StudentAuthenticationDialog({
  title,
  description,
  source,
  children,
}: {
  title: string
  description: string
  source?: string
  children: React.ReactElement
}) {
  const [open, setOpen] = useState(false)

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader className="p-2 sm:p-6">
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <AccountForm source={source} tokenize={true} />
      </DialogContent>
    </Dialog>
  )
}
